import { Tooltip } from "@mui/material";
import React from "react";
import calender from "../../../assets/images/calender-icon.svg";
import clock from "../../../assets/images/clock.svg";
import {
  default as location,
} from "../../../assets/images/Location.svg";
import rupee from "../../../assets/images/hand-coin.svg"
import styles from "./index.module.scss";

interface EventDetailsSectionProps {
  eventName?: string;
  eventCost?: any;
  basePrice?: string | number;
  comapactedEventDetails?: CompactedEventDetailsSectionProps;
  venue?: string;
  duration?: string;
  eventDates?: string;
  currentSectionIndex: number;
}
export interface CompactedEventDetailsSectionProps {
  eventName?: string;
  venue?: string;
  eventDates?: string;
  duration?: string;
  // eventCost?: any;
}

const FormSubHeader: React.FC<EventDetailsSectionProps> = ({
  eventName = "Entrainment'25",
  basePrice,
  comapactedEventDetails = null,
  eventCost,
  currentSectionIndex
}) => {
  return (
    <div className={currentSectionIndex == 1 ? styles.  programDetailsRightAlign : styles.programDetails}>
      {currentSectionIndex !== 1 && comapactedEventDetails?.venue != "" && (
        <div className={styles.detailItem}>
          <img src={location}/>
          {/* <span>{comapactedEventDetails?.venue}</span> */}
          {comapactedEventDetails?.venue &&
            comapactedEventDetails?.venue?.length > 40 ? (
            <Tooltip title={comapactedEventDetails?.venue} arrow placement="top">
              <span>
                {comapactedEventDetails?.venue?.slice(0, 40)}
                {"..."}
              </span>
            </Tooltip>
          ) : (
            comapactedEventDetails?.venue
          )}
        </div>
      )}
      {/* <div className={styles.detailItem}>
        <img src={clock} />
        <span>{comapactedEventDetails?.duration}</span>{" "}
      </div> */}
      <div className={styles.detailItem} >
        <img src={rupee} className={styles.icon} />
        {eventCost ? (
          Object.entries(eventCost).map(([key, value], index) => {
            return (
              <span className={styles.eventCost} key={key}>
                {key} : {" INR "}
                {Number(value).toLocaleString("en-IN")}
                {Object.entries(eventCost).length - 1 !== index ? (
                  <div className={styles.verticalDivider}></div>
                ) : (
                  ""
                )}
              </span>
            )

          })
        ) : (
          <div className={styles.detailItem}>
            <img src={rupee} />
            <span>{basePrice}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormSubHeader;
